import { Modal, Gap, Spinner, P } from '@salecycle/ui-component-library';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNewSftpUserState } from '../../../context/useNewSftpUserContext';

interface IProps {
  heading: string;
  isOpen: boolean;
  onCloseButtonClicked?: () => void;
  onCancelButtonClicked?: () => void;
  onOkButtonClicked?: (id: string) => void;
  okButtonLabel?: string;
  cancelButtonLabel?: string;
}

export const SummaryModal: React.FC<IProps> = ({
  heading,
  isOpen,
  onCloseButtonClicked,
  onCancelButtonClicked,
  onOkButtonClicked,
  okButtonLabel,
  cancelButtonLabel,
}: IProps) => {
  const { t } = useTranslation('sftpUserManagement');
  const [okButtonDisabled, setOkButtonDisabled] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);
  const { sftpUser } = useNewSftpUserState();

  useEffect(() => {
    if (isOpen) {
      setOkButtonDisabled(false);
      setShowSpinner(false);
    }
  }, [isOpen]);

  const handleOkButtonClicked = (id: string) => {
    //Once okay is clicked, disable it and show spinner so there is some
    //instant UI feedback while the request to create the user is in progress.
    setOkButtonDisabled(true);
    setShowSpinner(true);
    onOkButtonClicked(id);
  };

  return (
    <Modal
      heading={heading}
      variation="clean"
      isOpen={isOpen}
      onCloseButtonClicked={onCloseButtonClicked}
      onCancelButtonClicked={onCancelButtonClicked}
      onOkButtonClicked={handleOkButtonClicked}
      okButtonLabel={okButtonLabel}
      cancelButtonLabel={cancelButtonLabel}
      okButtonDisabled={okButtonDisabled}
      cancelButtonDisabled={showSpinner}
      customFooter={showSpinner ? <Spinner /> : null}
    >
      <P>{t('newSftpUser.summaryStep.modal.text', { name: sftpUser.username, email: sftpUser.email })}</P>
      <Gap top={10} />
      <P>{t('newSftpUser.summaryStep.modal.text2')}</P>
    </Modal>
  );
};

export default SummaryModal;
